let itemCounter = 0;

document.addEventListener('DOMContentLoaded', initAnnouncementBarScrolling);

function initAnnouncementBarScrolling() {
    const isMobile = window.innerWidth <= 740;
    if (!isMobile) {
        return;
    }
    const items = document.querySelectorAll('announcement-bar-item.announcement-bar__item');
    items.forEach(initAnnouncementBarItem);
}

function initAnnouncementBarItem(item) {
    const message = item.querySelector('.announcement-bar__message');
    if (!message) return;

    if (!item.dataset.scrollId) {
        item.dataset.scrollId = 'announcement-item-' + (itemCounter++);
    }
    const scrollId = item.dataset.scrollId;

    const checkScrolling = () => checkAndEnableScrolling(item, message, scrollId);

    setTimeout(checkScrolling, 100);
    setupMutationObserver(item, message, checkScrolling);
}

function checkAndEnableScrolling(item, message, scrollId) {
    disableScrolling(message);

    const itemWidth = item.offsetWidth;
    const messageWidth = message.scrollWidth;

    if (messageWidth > itemWidth) {
        // Text is cut - start from beginning and scroll
        enableScrolling(item, message, scrollId);
    } else {
        // Text is not cut - center it without scroll
        disableScrolling(message);
    }
    // Show the message after measurement and positioning is complete
    message.classList.add('visible');
}

function enableScrolling(item, message, scrollId) {
    const itemWidth = item.offsetWidth;
    const messageWidth = message.scrollWidth;
    const scrollDistance = messageWidth - itemWidth + 50;
    item.classList.add('scrolling');

    createScrollAnimation(scrollId, scrollDistance);
   
    message.setAttribute('data-scroll-id', scrollId);

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            message.classList.remove('announcement-bar__message--no-animation');
            message.classList.add('announcement-bar__message--scrolling');
            // Keep reset-transform briefly, then remove it after animation starts
            setTimeout(() => {
                message.classList.remove('announcement-bar__message--reset-transform');
            }, 50);
        });
    });
}

function disableScrolling(message) {
    message.classList.add('announcement-bar__message--no-animation');
    message.classList.add('announcement-bar__message--reset-transform');
    message.classList.remove('announcement-bar__message--scrolling');
}

function createScrollAnimation(scrollId, scrollDistance) {
    const styleSheetId = 'announcement-scroll-' + scrollId;
    let styleSheet = document.getElementById(styleSheetId);

    if (!styleSheet) {
        styleSheet = document.createElement('style');
        styleSheet.id = styleSheetId;
        document.head.appendChild(styleSheet);
    }

    // for different text lengths
    styleSheet.textContent = `
        @keyframes scroll-horizontal-${scrollId} {
            0% { transform: translateX(0); }
            20% { transform: translateX(0); }
            80% { transform: translateX(${scrollDistance}px); }
            100% { transform: translateX(${scrollDistance}px); }
        }
        .announcement-bar__message--scrolling[data-scroll-id="${scrollId}"] {
            animation-name: scroll-horizontal-${scrollId};
        }
    `;
}

function setupMutationObserver(item, message, checkAndEnableScrolling) {
    const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
                const isHidden = item.hasAttribute('hidden');

                if (isHidden) {
                    disableScrolling(message);
                } else {
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            message.classList.remove('announcement-bar__message--no-transition');
                            checkAndEnableScrolling();
                        }, 50);
                    });
                }
            }
        });
    });

    mutationObserver.observe(item, {
        attributes: true,
        attributeFilter: ['hidden']
    });
}